import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import { createStore, generateMutationTypes } from './storeFactory';

const buildAssistantFormData = assistantParams => {
  const formData = new FormData();
  const {
    config = {},
    response_guidelines,
    guardrails,
    ...assistantProperties
  } = assistantParams;

  // Add top-level properties with assistant[] wrapper
  Object.keys(assistantProperties).forEach(key => {
    if (
      assistantProperties[key] !== undefined &&
      assistantProperties[key] !== null
    ) {
      formData.append(`assistant[${key}]`, assistantProperties[key]);
    }
  });

  // Add config properties
  Object.keys(config).forEach(key => {
    if (config[key] !== undefined && config[key] !== null) {
      // If the value is an array, send it as JSON
      const value = Array.isArray(config[key]) ? JSON.stringify(config[key]) : config[key];
      formData.append(`assistant[config][${key}]`, value);
    }
  });

  // Add arrays if present
  if (response_guidelines) {
    formData.append(
      `assistant[response_guidelines]`,
      JSON.stringify(response_guidelines)
    );
  }
  if (guardrails) {
    formData.append(`assistant[guardrails]`, JSON.stringify(guardrails));
  }

  return formData;
};

const mutationTypes = generateMutationTypes('CaptainAssistant');

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: () => ({
    create: async ({ commit }, { isFormData = false, ...assistantParams }) => {
      commit(mutationTypes.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await CaptainAssistantAPI.create(
          isFormData ? buildAssistantFormData(assistantParams) : assistantParams
        );
        commit(mutationTypes.UPSERT, response.data);
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { creatingItem: false });
      }
    },
    update: async (
      { commit },
      { id, isFormData = false, ...assistantParams }
    ) => {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainAssistantAPI.update(
          id,
          isFormData ? buildAssistantFormData(assistantParams) : assistantParams
        );
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
